module.exports = __webpack_public_path__ + "media/images/home/step-warehouse-273912150036d596a969fe919cde7286.png";